import { logStreamError } from '../utils/globalErrorLogger';
import { getStorageDownloadDiagnostics } from './storageDownloadDiagnostics';

/**
 * Builds a Firestore `onSnapshot` error handler that always logs to Cloud
 * Logging (via `logStreamError`, which downgrades expected
 * permission-denied / unavailable noise to WARNING) AND forwards to a
 * caller-supplied handler if one was passed. Centralizing this means every
 * `subscribeTo*` helper gets stream-error coverage without each callsite
 * having to remember to log.
 */
export function wrapSubscriptionError(
  context: string,
  onError?: (err: Error) => void,
  metadata?: Record<string, unknown>,
): (err: Error) => void {
  return (err) => {
    const storageDiagnostics = getStorageDownloadDiagnostics(err);
    logStreamError(err, {
      context,
      ...((metadata || storageDiagnostics) ? { metadata: { ...metadata, ...storageDiagnostics } } : {}),
    });
    onError?.(err);
  };
}
